"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _PostListItem = _interopRequireDefault(require("./PostListItem"));

var _RecentCampaigns = _interopRequireDefault(require("../../RecentCampaigns"));

require("../styles/_posts-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FILTERS = {
  date: [{
    label: 'DATE CREATED',
    value: 'createdAt'
  }, {
    label: 'DATE UPDATED',
    value: 'updatedAt'
  }],
  status: [{
    label: 'ALL STATUS',
    value: void 0
  }, {
    label: 'PUBLISHED',
    value: 'PUBLISHED'
  }, {
    label: 'DRAFT',
    value: 'DRAFT'
  }],
  byCurrentUser: [{
    label: 'ALL USERS',
    value: false
  }, {
    label: 'ONLY MY POSTS',
    value: true
  }]
};
var MODAL = {
  DELETE: 'DELETE',
  PUBLISH: 'PUBLISH'
};

var PostsList = /*#__PURE__*/function (_Component) {
  _inherits(PostsList, _Component);

  function PostsList() {
    var _this;

    _classCallCheck(this, PostsList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PostsList).call(this));

    _defineProperty(_assertThisInitialized(_this), "onFiltersChange", function (_ref) {
      var searchTerm = _ref.searchTerm,
          _ref$filters = _ref.filters,
          status = _ref$filters.status,
          byCurrentUser = _ref$filters.byCurrentUser,
          date = _ref$filters.date;
      var refetchPosts = _this.props.refetchPosts;

      _this.setState({
        searchTerm: searchTerm,
        status: status,
        byCurrentUser: byCurrentUser,
        sortBy: date
      }, function () {
        return refetchPosts({
          status: status,
          byCurrentUser: byCurrentUser,
          searchTerm: searchTerm,
          sortBy: date
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBulkDelete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, bulkDeleteInspirations, refetchPosts, _this$state, status, byCurrentUser, searchTerm, sortBy, selectedInspirationIds, _ref3, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, bulkDeleteInspirations = _this$props.bulkDeleteInspirations, refetchPosts = _this$props.refetchPosts;
              _this$state = _this.state, status = _this$state.status, byCurrentUser = _this$state.byCurrentUser, searchTerm = _this$state.searchTerm, sortBy = _this$state.sortBy, selectedInspirationIds = _this$state.selectedInspirationIds;
              _context.next = 4;
              return bulkDeleteInspirations(selectedInspirationIds);

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;
              error = _ref3.error;

              if (!(!data || !data.bulkDeleteInspirations || error)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              _this.hideModal();

              refetchPosts({
                status: status,
                byCurrentUser: byCurrentUser,
                searchTerm: searchTerm,
                sortBy: sortBy
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleBulkPublish", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, bulkPublishInspirations, refetchPosts, _this$state2, status, byCurrentUser, searchTerm, sortBy, selectedInspirationIds, _ref5, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, bulkPublishInspirations = _this$props2.bulkPublishInspirations, refetchPosts = _this$props2.refetchPosts;
              _this$state2 = _this.state, status = _this$state2.status, byCurrentUser = _this$state2.byCurrentUser, searchTerm = _this$state2.searchTerm, sortBy = _this$state2.sortBy, selectedInspirationIds = _this$state2.selectedInspirationIds;
              _context2.next = 4;
              return bulkPublishInspirations(selectedInspirationIds);

            case 4:
              _ref5 = _context2.sent;
              data = _ref5.data;
              error = _ref5.error;

              if (!(!data || !data.bulkPublishInspirations || error)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return");

            case 9:
              _this.hideModal();

              refetchPosts({
                status: status,
                byCurrentUser: byCurrentUser,
                searchTerm: searchTerm,
                sortBy: sortBy
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "openConfirmModal", function (actionType) {
      return function (items) {
        _this.setState({
          modalOpened: actionType,
          selectedInspirationIds: items.map(function (_ref6) {
            var inspirationId = _ref6.inspirationId;
            return inspirationId;
          })
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "hideModal", function () {
      _this.setState({
        modalOpened: void 0,
        selectedInspirationIds: void 0
      });
    });

    _this.state = {
      searchTerm: void 0,
      status: void 0,
      byCurrentUser: void 0,
      sortBy: void 0,
      modalOpened: void 0,
      selectedInspirationIds: void 0
    };
    return _this;
  }

  _createClass(PostsList, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          posts = _this$props3.posts,
          totalResults = _this$props3.totalResults,
          loadMore = _this$props3.loadMore,
          getPostsListRef = _this$props3.getPostsListRef,
          loading = _this$props3.loading,
          history = _this$props3.history,
          showPublishConfirmationModal = _this$props3.showPublishConfirmationModal,
          showDeleteConfirmationModal = _this$props3.showDeleteConfirmationModal,
          showFeaturedConfirmationModal = _this$props3.showFeaturedConfirmationModal,
          showEditPostModal = _this$props3.showEditPostModal,
          orgPermissions = _this$props3.orgPermissions;
      var modalOpened = this.state.modalOpened;
      return _react.default.createElement("div", {
        className: "page__content posts-list"
      }, _react.default.createElement(_RecentCampaigns.default, null), _react.default.createElement(_uiKit.List, {
        history: history,
        renderListItem: (0, _PostListItem.default)({
          showPublishConfirmationModal: showPublishConfirmationModal,
          showDeleteConfirmationModal: showDeleteConfirmationModal,
          showFeaturedConfirmationModal: showFeaturedConfirmationModal,
          showEditPostModal: showEditPostModal,
          orgPermissions: orgPermissions
        }),
        data: posts,
        totalResults: totalResults,
        loadMoreResults: loadMore,
        getInfiniteScrollParent: getPostsListRef,
        emptyDataText: "Create your first Inspiration by clicking the 'Create New Post' button above",
        filters: FILTERS,
        loading: loading,
        listKey: "inspirationId",
        onFiltersChange: this.onFiltersChange,
        bulkActions: [{
          icon: 'trash',
          action: this.openConfirmModal(MODAL.DELETE),
          requiredPermission: 'DELETE',
          label: 'Delete Posts'
        }, {
          icon: 'publish',
          action: this.openConfirmModal(MODAL.PUBLISH),
          requiredPermission: 'UPDATE',
          label: 'Publish Posts'
        }]
      }), _react.default.createElement(_commonReact.ConfirmationModal, {
        title: "Are you sure?",
        subtitle: "Are you sure you want to ".concat(modalOpened === MODAL.DELETE ? 'Delete' : 'change the publish status of', "\n                these posts?"),
        visible: Boolean(modalOpened),
        onClose: this.hideModal,
        onSave: modalOpened === MODAL.DELETE ? this.handleBulkDelete : this.handleBulkPublish
      }));
    }
  }]);

  return PostsList;
}(_react.Component);

exports.default = PostsList;